export default "__VITE_ASSET__35a1d5ab__"